import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgGuide(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="3 -4 18 24" {...props}>
      <path
        d="M19 12.75c-.567.044-4.384.248-6 .738V2.753a9.636 9.636 0 012.184-.547v4.815h1.754V2.056c.246-.014 1.523-.09 2.062-.13zm-8 .738c-1.616-.49-5.434-.694-6-.738V1.996c.539.039 4.405.175 6 .757zm1.144-12.326l-.145.055-.144-.055C10.59.684 7.64.296 3 0v14.332c4.273.282 6.917.597 7.933.943V16h2.135v-.725c1.015-.346 3.659-.661 7.932-.943V0c-4.64.296-7.592.684-8.856 1.162z"
        fill="currentColor"
      />
    </svg>
  );
}

export default tombacIcon('Guide')(SvgGuide);
